import { useEffect, useState } from 'react';
import { prefersReducedMotion } from '../../site/utils/random';

const FADE_SECONDS = 1.2;

// Starts the muted hero timelapse and fades it in/out at each loop boundary so the cut never shows.
// Returns true once the video is actually playing (the still photo is hidden from then on).
const useHeroVideo = (videoRef) => {
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || prefersReducedMotion()) return undefined;

    let frame = 0;
    const tick = () => {
      const { duration, currentTime } = video;
      if (duration > 0 && Number.isFinite(duration)) {
        const opacity = Math.max(0, Math.min(1, currentTime / FADE_SECONDS, (duration - currentTime) / FADE_SECONDS));
        video.style.opacity = opacity.toFixed(3);
      }
      frame = requestAnimationFrame(tick);
    };
    const onPlaying = () => {
      setPlaying(true);
      cancelAnimationFrame(frame);
      tick();
    };
    const onPause = () => cancelAnimationFrame(frame);

    // React does not reliably reflect the `muted` attribute, and browsers only autoplay muted video.
    video.muted = true;
    video.addEventListener('playing', onPlaying);
    video.addEventListener('pause', onPause);
    video.play()?.catch(() => {});

    return () => {
      cancelAnimationFrame(frame);
      video.removeEventListener('playing', onPlaying);
      video.removeEventListener('pause', onPause);
    };
  }, [videoRef]);

  return playing;
};

export default useHeroVideo;
